<script>
import concat from "ramda/src/concat";
import remove from "ramda/src/remove";
import update from "ramda/src/update";
import config from "../config";

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      config,
      sequenceId: this.value.length,
    };
  },

  methods: {
    addArea() {
      this.$emit(
        "input",
        concat(this.value, [
          { ...this.newArea(), id: this.sequenceId.toString() },
        ])
      );
      this.sequenceId += 1;
    },

    newArea() {
      throw new Error("Accordions must implement the new area method");
    },

    updateArea(area, index) {
      this.$emit("input", update(index, area, this.value));
    },

    deleteArea(index) {
      this.$emit("input", remove(index, 1, this.value));
    },
  },
};
</script>
